import { NavLink } from "react-router";

type Props = {
  status?: "disabled" | "blocked" | string;
};

/** Shown in the content area when a business has been disabled/blocked by an admin. */
const BusinessSuspended = ({ status = "disabled" }: Props) => {
  const blocked = status === "blocked";
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="max-w-md w-full rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <span
          className={`mx-auto mb-4 flex size-14 items-center justify-center rounded-full ${
            blocked ? "bg-rose-100 text-rose-600" : "bg-amber-100 text-amber-600"
          }`}
        >
          <i className={`fas ${blocked ? "fa-ban" : "fa-circle-pause"} text-xl`} />
        </span>
        <h1 className="text-lg font-semibold text-slate-800">
          {blocked ? "Your business is blocked" : "Your business is disabled"}
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          {blocked
            ? "Access to the portal has been suspended by an administrator. Please contact support to resolve this."
            : "Your account is temporarily turned off, so day-to-day operations are paused. You can still review your subscription, or contact support to restore access."}
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          {!blocked && (
            <NavLink
              to="/dashboard/subscription"
              className="rounded-xl bg-teal-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-teal-800"
            >
              View subscription
            </NavLink>
          )}
          <a
            href="mailto:support@basisthan.com"
            className="rounded-xl border border-slate-300 px-5 py-2.5 text-sm font-medium text-slate-600 hover:border-teal-900"
          >
            Contact support
          </a>
        </div>
      </div>
    </div>
  );
};

export default BusinessSuspended;
